import {FormInstance} from "antd/es/form";
import {AxiosError} from "axios";

export interface ServerConstraintViolation {
    type: string;
    value: string;
    message: string;
    validationDone?: boolean;
}

export interface ServerConstraintViolations {
    constraintViolations: Record<string, Record<string, ServerConstraintViolation>>;
}

export class ServerConstraintViolationsHolder {
    public violations: ServerConstraintViolations = {constraintViolations: {}};

    constructor() {
        this.clearViolations();
    }

    public clearViolations(): void {
        this.violations = {constraintViolations: {}};
    }

    public createServerValidator(violationType: string, attribute?: string, messageFormatterFnc?: (message: string) => string | React.ReactNode) {
        return (rule: any, value: any) => {
            const attributeViolations = this.violations.constraintViolations[(attribute) ? attribute : rule.field];

            if (attributeViolations) {
                const typeViolation: any = attributeViolations[violationType];

                if (typeViolation) {
                    if (typeViolation.value && typeViolation.value !== value) {
                        return Promise.resolve();
                    }

                    if (!typeViolation.validationDone) {
                        typeViolation.validationDone = true;

                        if (messageFormatterFnc) {
                            return Promise.reject(messageFormatterFnc(typeViolation.message));
                        } else {
                            return Promise.reject(typeViolation.message);
                        }
                    }
                }
            }

            return Promise.resolve();
        }
    }

    public static containsConstraintViolations(object: any): object is ServerConstraintViolations {
        return (object as ServerConstraintViolations).constraintViolations !== undefined;
    }

    public handleServerError(error: AxiosError, form: FormInstance) {
        if (error && error.response && error.response.data && ServerConstraintViolationsHolder.containsConstraintViolations(error.response.data)) {
            this.violations = error.response.data;

            form.validateFields();

            return Promise.resolve();
        } else {
            return Promise.reject(error);
        }
    }

}
